(function ($) {
    $(document).ready(function () {

        const time = 4000, speed = 500;
        const modal = $(".member-modal"), html = $("html");

        const swiperOptions = {
            loop: true,
            spaceBetween: 20,
            slidesPerView: "auto",
            allowTouchMove: true,
            navigation: {
                nextEl: ".section-leadership .next",
                prevEl: ".section-leadership .prev",
            },
            autoplay: {
                delay: time,
                disableOnInteraction: false
            },
            speed: speed,
            breakpoints: {
                320: {
                    slidesPerView: 1,
                },
                600: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: "auto",
                }
            }
        };

        const slider = new Swiper(".section-leadership .swiper", swiperOptions);

        slider.on("click", (slider) => {
            slider.autoplay.stop();
            let index = $(slider.clickedSlide).data("swiper-slide-index");
            html.addClass("active-modal");
            modal.find(".modal-item").eq(index).addClass("active");
        })

        $(".close-modal, .member-modal-wrap").on("click", () => {
            modal.find(".modal-item").removeClass("active");
            html.removeClass("active-modal");
            slider.autoplay.start();
        });

        modal.on("click", (e) => {
            e.stopPropagation();
        })

    })
})(jQuery);
